import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        disabled: '=',
        form: '='
    },
    template: `
    <hr>
    <div class="form" ng-if="vm.form.model.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT">
        <ul class="checkboxes">
            <li>
                <label>
                    <input type="checkbox" ng-change="vm.confirmAssessmentChange()" ng-model="vm.form.model.isAssessmentNeeded">
                    {{ 'questionAnswer.Needs manual assesment' | translate }}
                </label>
            </li>
        </ul>
        <div class="row ng-scope" ng-if="vm.showPoints">
            <label class="label">{{ 'questionAnswer.Maximum points' | translate }}</label>
            <div class="items">
                <input type="number" class="form-control small02" ng-model="vm.form.model.points">
            </div>
        </div>
    </div>
    `
})

export default class {
    constructor ($translate, ModalService, QUESTIONS_TYPE_ENUM) {
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.showPoints = this.form.model.isAssessmentNeeded;
    }

    confirmAssessmentChange () {
        this.ModalService.confirm(
            this.$translate.instant('question.You are about to add/remove the possibility to assess a free text question. Are you sure you wish to continue?'),
            'medium'
        ).then(() => {
            this.form.model.points = null;
        })
        .catch(() => {
            this.form.model.isAssessmentNeeded = !this.form.model.isAssessmentNeeded;
        })
        .finally(() => {
            this.showPoints = this.form.model.isAssessmentNeeded;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/actions/answers/freeTextType/index.js